import "../styles/app.scss";
import "./_images";
import { GravityForm } from "./helpers/GravityForm";

document.addEventListener(
  "DOMContentLoaded",
  () => {
    new GravityForm();
    document.addEventListener("click", (e) => {
      if (e.target.closest("button[href]")) {
        e.preventDefault();
        window.location = e.target.closest("button[href]").getAttribute("href");
      }
    });
  },
  false,
);
